import { PlusCircleIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'

import { useRoute } from '../../../hooks/useRoute'
import { RootState } from '../../../redux/store'
import { Snippet } from '../../../services/models/Snippet.model'
import { BackButton } from '../../UI/BackButton'
import { Button } from '../../UI/Button'
import { SearchField } from '../../UI/SearchField'

interface Props {
    selectedId: string | null
    onSelect: (id: string) => void
}

export const SnippetsList = ({ selectedId, onSelect }: Props) => {
    const { snippets } = useSelector((state: RootState) => state.snippets)
    const [searchQuery, setSearchQuery] = useState('')
    const { snippetsRoute } = useRoute()
    const navigate = useNavigate()
    const handleSelect = useCallback(
        (id: string) => {
            onSelect(id)
        },
        [onSelect]
    )

    const filteredSnippets = snippets.filter((snippet: Snippet) => snippet?.abbreviation.toLowerCase().includes(searchQuery.toLowerCase()))

    return (
        <div className="flex flex-col border-r h-full">
            <BackButton type="arrow" className="bg-transparent" />
            {snippets.length === 0 ? (
                <div className="flex flex-col items-center justify-center h-full text-center p-4">
                    <h3 className="text-lg font-medium text-gray-900 mb-2">No snippets added</h3>
                    <p className="text-sm text-gray-500">Get started by adding a snippet</p>
                    <Button className="mt-4" leftIconNode={<PlusCircleIcon className="h-5 w-5" />} label="Add Snippet" onClick={() => navigate(snippetsRoute)} />
                </div>
            ) : (
                <>
                    <div className="flex flex-col items-center py-4 px-3 gap-3 justify-between">
                        <div className="flex-1 flex justify-between w-full">
                            <span className="text-xl font-medium">Snippets</span>
                            <Button leftIconNode={<PlusCircleIcon className="h-5 w-5" />} label="Add Snippet" onClick={() => navigate(snippetsRoute)} />
                        </div>
                        {snippets.length > 0 && <SearchField value={searchQuery} name="Snippets" onChange={setSearchQuery} placeholder="Search snippets..." className="w-full" />}
                    </div>

                    <div className="flex-1 border-t border-gray-100 overflow-y-auto">
                        {filteredSnippets.map((snippet: Snippet) => (
                            <NavLink
                                to={`/settings/snippets/${snippet.abbreviation}`}
                                state={{ snippetId: snippet.id }}
                                key={snippet.id}
                                className={classNames(
                                    'flex items-center justify-between',
                                    'cursor-pointer p-3 border-b border-gray-100  hover:bg-gray-100',
                                    selectedId === snippet.id ? 'bg-gray-200' : ''
                                )}
                            >
                                <div className="flex-1" onClick={() => handleSelect(snippet.id)}>
                                    <div className="text-base text-gray-700">/{snippet.abbreviation}</div>
                                </div>
                            </NavLink>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}
